import animateScrollTo, {IOptions} from 'animated-scroll-to';
import {Settings} from '../global/Settings';

export function scrollToElement(el: HTMLElement, delay = 0, speed = 750) {
	if (!el) {
		return;
	}

	const scrollOptions: IOptions = {
		speed,
		verticalOffset: -Settings.getInstance().getScrollSpace(),
	};

	if (delay) {
		setTimeout(() => animateScrollTo(el, scrollOptions), delay);
	} else {
		requestAnimationFrame(() => animateScrollTo(el, scrollOptions));
	}
}
